import type {
  SystemWorkspaceDefinition,
} from './SystemWorkspaceContracts';

import {
  membershipBillingSystemWorkspace,
} from './MembershipBillingSystemWorkspace';

import {
  callsSystemWorkspace,
} from './CallsSystemWorkspace';

import {
  treeSystemWorkspace,
} from './TreeSystemWorkspace';

const workspaceDefinitions:
  SystemWorkspaceDefinition[] = [
    treeSystemWorkspace,
    membershipBillingSystemWorkspace,
    callsSystemWorkspace,
  ];

const workspaceRegistry = new Map(
  workspaceDefinitions.map(workspace => [
    workspace.id,
    workspace,
  ]),
);

export function listSystemWorkspaces():
  SystemWorkspaceDefinition[] {
  return [...workspaceRegistry.values()];
}

export function getSystemWorkspace(
  systemId: string,
): SystemWorkspaceDefinition | null {
  return workspaceRegistry.get(systemId) ?? null;
}

export function registerSystemWorkspace(
  workspace: SystemWorkspaceDefinition,
): void {
  if (workspaceRegistry.has(workspace.id)) {
    throw new Error(
      `System workspace already registered: ${workspace.id}`,
    );
  }

  workspaceRegistry.set(
    workspace.id,
    workspace,
  );
}

export function hasSystemWorkspace(
  systemId: string,
): boolean {
  return workspaceRegistry.has(systemId);
}
